export default __webpack_public_path__ + "static/media/Video-poster.ecfa5d6b.png";